import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-icon danger">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>

        <h3 className="modal-title">{title || "Conferma Eliminazione"}</h3>
        <p className="modal-message">
          {message || "Sei sicuro di voler eliminare questo elemento? Questa azione non può essere annullata."}
        </p>

        <div className="modal-actions">
          <button type="button" className="btn-modal cancel" onClick={onCancel}>
            Annulla
          </button>
          <button type="button" className="btn-modal confirm-danger" onClick={onConfirm}>
            Elimina
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
